/**
 * Quantity block: subscription/one-time option cards on product form.
 * Handles selection, main price/compare price, sticky ATC, and welcome kit modal.
 */
(function() {
  const quantityBlock = document.querySelector('[data-quantity-block]');
  if (!quantityBlock) return;

  function formatPriceToTwoDecimals(priceElement) {
    if (!priceElement) return;
    const priceText = priceElement.textContent.trim();
    const priceMatch = priceText.match(/[\d.]+/);
    if (priceMatch) {
      const priceNum = parseFloat(priceMatch[0]);
      if (!isNaN(priceNum)) {
        if (priceText.includes('$')) {
          priceElement.textContent = '$' + priceNum.toFixed(2);
        } else {
          priceElement.textContent = priceNum.toFixed(2);
        }
      }
    }
  }

  function formatAllPrices() {
    // Only format prices inside the quantity-block cards (.formatted-price).
    // [data-current-price] is now owned by updateSelection via Utility.formatMoney.
    quantityBlock.querySelectorAll('.formatted-price').forEach(priceEl => {
      formatPriceToTwoDecimals(priceEl);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', formatAllPrices);
  } else {
    formatAllPrices();
  }
  setTimeout(formatAllPrices, 100);

  const variantInput = document.getElementById('quantity-block-variant-id');
  const sellingPlanInput = document.getElementById('quantity-block-selling-plan');
  const optionCards = quantityBlock.querySelectorAll('[data-quantity-option]');
  const form = quantityBlock.closest('form');
  const addToCartBtn = form?.querySelector('[data-add-to-cart-button]');

  let userHasInteracted = false;
  let initializationComplete = false;

  function updateSelection(selectedCard, isProgrammatic = false) {
    if (!isProgrammatic) {
      userHasInteracted = true;
    }
    optionCards.forEach(card => {
      card.classList.remove('selected', 'border-primary', 'bg-white');
      card.classList.add('bg-light');
      card.style.backgroundColor = '';
      card.style.borderColor = '#e0e0e0';
      card.style.borderWidth = '3px';
    });
    selectedCard.classList.add('selected', 'bg-white');
    selectedCard.classList.remove('bg-light', 'border-primary');
    selectedCard.style.backgroundColor = 'white';
    selectedCard.style.borderColor = '#000';
    selectedCard.style.borderWidth = '3px';
    if (!selectedCard.classList.contains('border-2')) {
      selectedCard.classList.add('border-2');
    }

    const radio = selectedCard.querySelector('input[type="radio"]');
    if (radio) {
      radio.checked = true;

      const purchaseType = selectedCard.getAttribute('data-purchase-type');
      if (purchaseType === 'onetime') {
        const firstVariant = quantityBlock.querySelector('[data-variant-id]');
        if (firstVariant) {
          variantInput.value = firstVariant.getAttribute('data-variant-id');
        }
        sellingPlanInput.value = '';
      } else {
        variantInput.value = selectedCard.getAttribute('data-variant-id');
        sellingPlanInput.value = selectedCard.getAttribute('data-selling-plan-id') || '';
      }

      const productContainer = quantityBlock.closest('[data-product-container]');
      if (productContainer) {
        const mainPriceElement = productContainer.querySelector('[data-current-price]');
        const mainComparePriceElement = productContainer.querySelector('[data-current-com-price]');

        if (mainPriceElement) {
          // Read prices from globalVariables (cent values) rather than scraping
          // formatted DOM text — avoids circular parse/format path and uses the
          // store's money_format for correct non-USD display.
          let displayPriceCents = null;
          let comparePriceCents = null;
          const moneyFormat = window.globalVariables?.money_format;

          if (moneyFormat) {
            const variantId = variantInput.value;
            const variantData = window.globalVariables.product?.variants?.find(v => v.id == variantId);
            if (variantData) {
              if (purchaseType === 'onetime') {
                displayPriceCents = variantData.price;
                if (variantData.compare_at_price > variantData.price) {
                  comparePriceCents = variantData.compare_at_price;
                }
              } else {
                const sellingPlanId = sellingPlanInput.value;
                const allocation = variantData.selling_plan_allocations?.find(a => a.selling_plan_id == sellingPlanId);
                displayPriceCents = allocation?.price ?? variantData.price;
                const comparePriceCandidate = allocation?.compare_at_price ?? variantData.compare_at_price;
                if (comparePriceCandidate > displayPriceCents) {
                  comparePriceCents = comparePriceCandidate;
                }
              }
            }
          }

          if (displayPriceCents !== null) {
            mainPriceElement.textContent = Utility.formatMoney(displayPriceCents, moneyFormat);
            if (mainComparePriceElement) {
              if (comparePriceCents !== null) {
                mainComparePriceElement.textContent = Utility.formatMoney(comparePriceCents, moneyFormat);
                mainComparePriceElement.style.display = '';
                mainPriceElement.classList.add('text-danger');
              } else {
                mainComparePriceElement.style.display = 'none';
                mainPriceElement.classList.remove('text-danger');
              }
            } else if (comparePriceCents !== null) {
              mainPriceElement.classList.add('text-danger');
            } else {
              mainPriceElement.classList.remove('text-danger');
            }
          }
        }
      }

      if (addToCartBtn && !addToCartBtn.hasAttribute('data-quantity-block-button') && window.globalVariables) {
        const variantId = variantInput.value;
        const moneyFmt = window.globalVariables.money_format;
        const variantData = window.globalVariables.product?.variants?.find(v => v.id == variantId);
        if (variantData && moneyFmt) {
          let priceText = '';
          if (purchaseType === 'onetime') {
            priceText = Utility.formatMoney(variantData.price, moneyFmt);
          } else {
            const sellingPlanId = sellingPlanInput.value;
            const allocation = variantData.selling_plan_allocations?.find(a => a.selling_plan_id == sellingPlanId);
            const planPrice = allocation?.price ?? variantData.price;
            priceText = `${Utility.formatMoney(planPrice, moneyFmt)} (per shipment)`;
          }
          const addText = addToCartBtn.querySelector('.add-text');
          if (addText) {
            if (purchaseType === 'onetime') {
              addText.innerHTML = window.variantStrings?.addToCart || 'Add to cart';
            } else {
              const rcInput = document.querySelector('[data-product-container] recharge-widget custom-select ul li input');
              const disV = rcInput ? parseFloat(rcInput.getAttribute('data-discount') || 0) : 0;
              addText.innerHTML = disV ? `Subscribe & save ${disV}%` : 'Subscribe & save';
            }
          }
        }
      }

      if (window.globalVariables && variantInput.value) {
        const variantId = variantInput.value;
        const variantData = window.globalVariables.product?.variants?.find(v => v.id == variantId);
        if (variantData) {
          window.globalVariables.product.currentVariant = variantData;
          document.dispatchEvent(new Event('variant:changed'));
        }
      }

      updateStickyButton(purchaseType, variantInput.value);
    }
  }

  function updateStickyButton(purchaseType, variantId) {
    const stickyButtons = document.querySelectorAll('[data-atc-out]');
    if (!stickyButtons || stickyButtons.length === 0) return;

    let priceText = '';
    let isSoldOut = false;
    const moneyFormat = window.globalVariables?.money_format;

    if (moneyFormat) {
      const variantData = window.globalVariables.product?.variants?.find(v => v.id == variantId);
      if (variantData) {
        isSoldOut = variantData.available === false;
        if (purchaseType === 'onetime') {
          priceText = Utility.formatMoney(variantData.price, moneyFormat);
        } else {
          const sellingPlanId = sellingPlanInput.value;
          const allocation = variantData.selling_plan_allocations?.find(a => a.selling_plan_id == sellingPlanId);
          priceText = Utility.formatMoney(allocation?.price ?? variantData.price, moneyFormat);
        }
      }
    }

    if (!priceText) return;

    const addToCartText = window.variantStrings?.addToCart || 'Add to Cart';
    const soldOutText = window.variantStrings?.soldOut || 'Sold Out';
    let buttonText;
    if (isSoldOut) {
      buttonText = soldOutText;
    } else {
      buttonText = `${addToCartText} <span class="font-family-heading ls-0 lh-1"> <span class="mx-2">|</span> ${priceText}</span>`;
    }

    stickyButtons.forEach(stickyBtn => {
      stickyBtn.innerHTML = `<span class="add-text">${buttonText}</span><span class="spinner-border block__add-to-cart-spinner"></span>`;
      stickyBtn.disabled = isSoldOut;
    });
  }

  optionCards.forEach(card => {
    card.addEventListener('click', function(e) {
      userHasInteracted = true;
      if (e.target.tagName !== 'INPUT') {
        updateSelection(card);
      }
    });
  });

  quantityBlock.querySelectorAll('input[name="quantity_variant"]').forEach(radio => {
    radio.addEventListener('change', function() {
      userHasInteracted = true;
      const card = this.closest('[data-quantity-option]');
      if (card) {
        updateSelection(card);
      }
    });
  });

  function initializeDefaultSelection() {
    if (userHasInteracted || initializationComplete) return;
    const currentlyChecked = quantityBlock.querySelector('[data-quantity-option] input:checked');
    const defaultCard = currentlyChecked?.closest('[data-quantity-option]');
    if (!defaultCard) return;

    formatAllPrices();
    const expectedDefault = quantityBlock.querySelector('[data-quantity-option] input[checked]');
    if (currentlyChecked === expectedDefault && !userHasInteracted) {
      setTimeout(() => {
        if (!userHasInteracted) {
          formatAllPrices();
          updateSelection(defaultCard, true);
        }
        initializationComplete = true;
      }, 300);
    } else {
      formatAllPrices();
      initializationComplete = true;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initializeDefaultSelection, 100);
    });
  } else {
    setTimeout(initializeDefaultSelection, 100);
  }

  // Single delegated handler for welcome kit links — no MutationObserver needed
  // since these links are static server-rendered HTML.
  quantityBlock.addEventListener('click', function(event) {
    const link = event.target.closest('[data-welcome-kit]');
    if (!link) return;
    event.preventDefault();
    const siteOverlay = document.querySelector('site-overlay');
    const welcomeKitModal = document.querySelector('#welcome-kit');
    if (siteOverlay) siteOverlay.classList.add('overlay--body');
    if (typeof lockWelcomeKitScroll === 'function') {
      lockWelcomeKitScroll();
    } else {
      document.body.classList.add('scroll-fixed');
    }
    if (welcomeKitModal) welcomeKitModal.classList.add('d-block');
  });
})();
